<template>
  <FormFieldset
    :label="label"
    :patternLabel="patternLabel"
    :description="description"
    :error="error"
    :errorMessage="errorMessage"
    :req="req"
    :optional="optional"
  >
    <div class="formInput" :class="`-${size}`">
      <InputInlineText
        :id="id"
        :placeholder="placeholder"
        :error="error"
        :type="input.type"
        :value="value"
        :name="name"
        :disabled="disabled"
        :req="req || formGroupReq"
        @call-input-change="callInputChange"
      />
      <button
        v-if="passwordSwitch"
        type="button"
        class="eyeIcon"
        :class="{ '-off': input.type === 'text' }"
        tabindex="-1"
        @click="toggeleShowPwassword"
      />
    </div>
  </FormFieldset>
</template>

<script lang="ts">
import FormFieldset from '@/components/block/FormFieldset.vue'
import InputInlineText from '@/components/elements/InputInlineText.vue'
import { SetupContext, reactive } from 'vue'

export default {
  name: 'FormInputField',

  components: {
    FormFieldset,
    InputInlineText
  },

  props: {
    id: String,
    label: String,
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    formGroupReq: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: String,
    description: String,
    placeholder: String,
    size: String,
    passwordSwitch: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    value: String,
    name: String,
    type: String
  },

  setup(props: any, context: SetupContext) {
    const input = reactive({
      type: props.type
    })

    const callInputChange = (value: string) => {
      context.emit('change-message', value)
    }

    const toggeleShowPwassword = () => {
      input.type = input.type === 'text' ? 'password' : 'text'
    }

    return {
      input,
      callInputChange,
      toggeleShowPwassword
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.formInput {
  min-width: 280px;

  &.-lg {
    width: 75%;
  }
}

.eyeIcon {
  position: absolute;
  right: 16px;
  top: 50%;
  margin-top: -7px;

  &::before {
    content: '';
    display: block;
    width: 21px;
    height: 14px;
    background-image: url('~@/assets/icon/eye_on.svg');
    background-size: 21px 14px;
  }

  &.-off {
    margin-top: -9px;

    &::before {
      height: 18px;
      background-image: url('~@/assets/icon/eye_off.svg');
      background-size: 21px 18px;
    }
  }
}
</style>
